import { CART_PAGES, PAGE_TYPE_CHECKOUT } from 'shared/consts'
import { type PageType } from 'types/cmsTypes'

// TODO Merge into shared consts once the PQSL is approved for all tenants
export const EXCLUDED_PAGE_TYPES: PageType[] = [
  PAGE_TYPE_CHECKOUT,
  ...CART_PAGES,
]
